import actions from './actions'
import mutations from './mutations'
import getters from './getters'

let state = {
  user: null,
  firebaseUser: null
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}